import _BaseAPIService from "../_BaseAPIService";

const apiService = _BaseAPIService.instance;

const CreditLogService = {
  // Define your API functions here
  creditPay: async (customerId, data) => {
    const response = await apiService.post(
      `/creditlogs/customer/${customerId}/pay`,
      data
    );
    return response.data;
  },

  getList: async (customerId) => {
    const response = await apiService.get(`/creditlogs/customer/${customerId}`);
    return response.data;
  },

  getSummary: async (period) => {
    const response = await apiService.get(`/creditlogs/summary/${period}`);
    return response.data;
  },
};

export default CreditLogService;
